export const localStorageKey = 'hideAfterAllFeatureTrialPopupList';
export const showBeforeDays = 2;
export const showAfterDays = 45;
